import request from '@/router/axios'

export function fetchAnalysisSummary () {
    return request({
      url: '/post/admin/post/statistics/analysis/summary',
      method: 'get'
    })
}

export function getSummaryDataByPeriod (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/summary/period',
    method: 'get',
    params: param,
  })
}

export function exportAnalysisSummaryData(obj) {
  return request({
    url: '/post/admin/post/statistics/analysis/summary/export',
    method: 'put',
    data: obj,
  })
}

export function getPostStatisticsSummaryTrend (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/summary/trend',
    method: 'get',
    params: param,
  })
}

export function exportAnalysisSummaryTrendData (param) {
  return request({
    url: '/post/admin/post/statistics/analysis/summary/trend/export',
    method: 'get',
    params: param,
  })
}